export enum BookingOrigin {
  SEARCH,
  MIA,
}
